var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcastWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3203",
    "data-name": "Groupe 3203",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.579,
    height: 26.117,
    viewBox: "0 0 22.579 26.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 26.117,
    height: 4.839,
    rx: 2.419,
    transform: "translate(17.741 26.117) rotate(-90)",
    fill: "#f7f7f7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 20.225,
    height: 4.839,
    rx: 2.419,
    transform: "translate(8.747 23.173) rotate(-90)",
    fill: "#f7f7f7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 12.381,
    height: 4.839,
    rx: 2.419,
    transform: "translate(0 19.461) rotate(-90)",
    fill: "#f7f7f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastWhiteIcon);
export default __webpack_public_path__ + "static/media/podcastWhiteIcon.ce2340306431ff494edc3a88bc51a934.svg";
export { ForwardRef as ReactComponent };